import React, { useState } from 'react';
import Sidebar from './Sidebar';
import { Menu, Star } from 'lucide-react';

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="min-h-screen flex" style={{ background: 'linear-gradient(135deg, #e8eeff 0%, #d8f5ee 50%, #ede8ff 100%)' }}>
      {/* Sidebar Component */}
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />

      {/* Mobile Header Bar */}
      <header className="fixed top-0 left-0 right-0 h-16 bg-white border-b border-slate-100 flex items-center justify-between px-6 z-30 lg:hidden shadow-sm">
        <button
          onClick={toggleSidebar}
          className="p-2 rounded-xl text-brand-navy hover:bg-slate-50 transition-colors"
          aria-label="Open navigation menu"
        >
          <Menu className="w-6 h-6" />
        </button>
        
        {/* Brand name Centered in Header for Mobile */}
        <div className="flex items-center gap-1.5">
          <Star className="w-5 h-5 text-brand-purple fill-brand-purple/20 animate-spin-slow" style={{ animationDuration: '8s' }} />
          <span className="font-sans font-extrabold text-xl tracking-tight bg-gradient-to-r from-brand-purple to-brand-teal bg-clip-text text-transparent">
            Prakashguru
          </span>
        </div>

        {/* Dummy placeholder for spacing */}
        <div className="w-10" />
      </header>

      {/* Main Content Area */}
      <main className="flex-1 main-content-area flex flex-col relative min-h-screen overflow-hidden">
        {/* Page contents container */}
        <div className="flex-1 w-full flex flex-col justify-start z-10">
          {children}
        </div>
      </main>
    </div>
  );

};

export default Layout;
